module.exports = __webpack_public_path__ + "img/25.7afb496f.jpg";